export default __webpack_public_path__ + "static/bgImageLg-3c8a7be3698310757cca03cf7b3b0198.png";